// Import dependencies
import React from 'react';

// Import CSS & assets
import './Powered.css';
import logo_mistral from '../../../assets/logo/logo_mistral_white.svg';



const Powered = () => {
    return (
        <div className="landing__powered">
            <div className="landing__powered_text">Nos modèles d'IA sont propulsés par</div>
            <div className="landing__powered_logo">
                <img src={logo_mistral} alt="logo_mistral" />
            </div>
        </div>
    );
};

export default Powered;